/** Fixed list area height (~5 activity rows); scroll when content overflows. */
export const DASHBOARD_SIDE_CARD_LIST_HEIGHT_CLASS = "h-[22.5rem]";
